import { IncomingMessage } from "http";
import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import {useStores} from "../hooks/useStores";
import ImageStore from "../store/impl/ImageStore";
import PreviewImage from "./PreviewImage";

const FileLoaderButton = observer((props) => {
    const {ImageStore} = useStores();

    return <button onClick={async e => {
        const dir = await showDirectoryLoader()
        if (dir == null) return;
        const loadedImages = await showTree(dir, ImageStore);
        ImageStore.setImages(loadedImages);
    }}>Load Directory</button>;
});

async function showDirectoryLoader() {
    const dir = await window.showDirectoryPicker();
    return dir
}

// need return type definition because of recursive function call
async function showTree(dir: FileSystemDirectoryHandle, imageStore: ImageStore, parentPath: string = "") : Promise<JSX.Element[]>{
    const images = [];
    const promises = [];
    console.log(`loading ${parentPath}`);
    for await (const [fname, handle] of dir.entries()) {
        switch (handle.kind) {
            case "directory":
                // recursive
                const dirPath = parentPath + "/" + fname;
                //console.log(`dir: ${dirPath}`);
                const subImages = await showTree(handle, imageStore, dirPath);
                images.push(...subImages);
                break;
            case "file":
                if (isImage(fname) == false) {
                    break;
                }
                promises.push((async () => {
                    const url = await loadImage(dir, fname);
                    const img = createImage(parentPath + "/" + fname, imageStore, url);
                    return img;
                })());

                break;
            default:
                break;
        }
    }
    // load images
    if (promises.length > 0) {
        const loadedImage = await Promise.all(promises);
        images.push(...loadedImage);
    }
    return images;
}

async function loadImage(parent: FileSystemDirectoryHandle, path: string) {
    const fileHandle = await parent.getFileHandle(path);
    const file = await fileHandle.getFile();
    // note: 画像表示だけならpngでもimage/jpgで表示できる
    const data = await file.arrayBuffer();
    const blob = new Blob([data], { type: "image/jpg" });
    const url = URL.createObjectURL(blob);
    return url;
}

function createImage(path: string, imageStore: ImageStore, dataUrl: string) {
    const previewImage = <PreviewImage dataUrl={dataUrl}></PreviewImage>;
    const img = <img
        src={dataUrl} key={path} className="ImageView-img"
        onMouseOver={() => {
            imageStore.setPreviewImage(previewImage);
        }}
        onMouseOut={() => {
            imageStore.unsetPreviewImage();
        }}
        onClick={() => {
            imageStore.unlockPreviewImage();
            imageStore.setPreviewImage(previewImage);
            imageStore.lockPreviewImage();
            console.log(img.key);
        }}
    ></img>;
    return img;
}

function isImage(fname : string) {
    const imageExts = [".jpg", ".jpeg", ".png"];
    for (const ext of imageExts) {
        if (fname.toLowerCase().endsWith(ext))  return true;
    }
    return false;
}

export default FileLoaderButton;
